import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { useTranslation } from "react-i18next";
import { Badge, Card, Group, Loader, Stack, Text } from "@mantine/core";
import toast from "react-hot-toast";

import { EmptyMessage } from "@components/shared";

function statusColor(status) {
  if (status === 1) return "green";
  if (status === 2) return "gray";
  if (status === 3) return "red";
  return "gray";
}

export default function AssessmentInstrumentList({ refresh = false }) {
  const { t } = useTranslation();
  const [instruments, setInstruments] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchInstruments();
  }, [refresh]);

  function fetchInstruments() {
    setLoading(true);
    const body = { page: 0, page_size: 100, scope: "entire" };

    axios
      .post(`/retrieve-assessment-instruments/`, body)
      .then(({ data }) => {
        setInstruments(data.response[0]?.data || []);
        setLoading(false);
      })
      .catch(() => {
        axios
          .post(`/retrieve-assessment-instruments/`, {
            page: 0,
            page_size: 100,
            status: "entire",
          })
          .then(({ data }) => {
            setInstruments(data.response[0]?.data || []);
            setLoading(false);
          })
          .catch((err) => {
            setLoading(false);
            toast.error(err);
          });
      });
  }

  if (loading) {
    return (
      <Group justify="center" py="xl">
        <Loader size="sm" />
      </Group>
    );
  }

  return (
    <Stack gap="sm">
      {!instruments.length && <EmptyMessage />}
      {instruments.map((instrument) => (
        <Card
          key={instrument.id}
          component={Link}
          to={`/instruments/${instrument.id}`}
        >
          <Group justify="space-between" align="flex-start">
            <div>
              <Text c="dark" fw={700}>
                {instrument.name}
              </Text>
              {instrument.variety_formatted && (
                <Text size="sm" c="dimmed">
                  {instrument.variety_formatted}
                </Text>
              )}
            </div>
            <Group gap="xs">
              {instrument.locked && (
                <Badge variant="filled" color="orange">
                  Locked
                </Badge>
              )}
              <Badge variant="light" color={statusColor(instrument.status)}>
                {instrument.status_formatted || t("status")}
              </Badge>
            </Group>
          </Group>
        </Card>
      ))}
    </Stack>
  );
}
